
import React, { Component } from 'react'
import ReactDOM from 'react-dom';
import DataService from '../../lib/DataService';
import SharedTools from '../../lib/SharedTools';
import UserRoleStore from '../../stores/UserRoleStore';
import CurrentRoleStore from '../../stores/CurrentRoleStore';
import CurrentRoleActions from '../../actions/CurrentRoleActions';
import { hashHistory, Link } from 'react-router';
import ReactQiniuModule from '../../../../lib/ReactQiniuModule';

import { Button, Modal, Input, message, Row, Col, Table, Popover, Select, Switch, Icon, Spin,Tabs, Popconfirm } from 'antd';
const Search = Input.Search;
const Option = Select.Option;
const schoolChangeConfirm = Modal.confirm;
const TabPane = Tabs.TabPane;

export default class AdminIndexPage extends Component {
  constructor(props) {
      super(props);
      // set state
      this.state = {
        role: CurrentRoleStore.getCurrentRole(),
        roles: UserRoleStore.getState(),
        systemAdmin: UserRoleStore.getState().find((role) => role.associatName == 'system'),
        visible: false,
        hasSearched: false,
        searchSchoolResult: [],
        studentPageCount:[],
        editTeacherVisible: false,
        studentPageVisible: false,
        searchTeacher: undefined,
        addStudentVisible:false,
        searchId:0,

        // 公众号设置
        inputKeyword: '',
        autoReplies: [],
        autoRepliesMedias: [],
        autoRepliesList: [],
        repliesRecord: undefined,

        //pdf任务管理
        taskList: [],
        classList:[],
        studentList:[],
        schoolList:[],
        task: {
          school_id: undefined,
          semester: undefined,
          class_id: undefined,
          addStudent:undefined,
          student_id: [],
          is_printable: true,
          is_compress: true,
        },

        // 上传主题评价
        uploading: false,
        type_options: [{
          label: '3颗星-有领域',
          type: 2
        }, {
          label: '3颗星-无领域',
          type: 3
        }, {
          label: '4颗星-有领域',
          type: 0
        }, {
          label: '4颗星-无领域',
          type: 1
        },  {
          label: '5颗星-有领域',
          type: 4
        }, {
          label: '5颗星-无领域',
          type: 5
        }],

        theme_options: [{
          label: '绿色小班',
          type: 0
        }, {
          label: '黄色中班',
          type: 2
        }, {
          label: '蓝色大班',
          type: 1
        }, {
          label: '盐官老师',
          type: 3
        }, {
          label: '盐官家长',
          type: 4
        }, {
          label: '蓝色通用',
          type: 5
        }, {
          label: '蓝色老师',
          type: 8
        }, {
          label: '蓝色家长',
          type: 9
        }, {
          label: '丁桥',
          type: 6
        }, {
          label: '梅园小班',
          type: 7
        },{
          label: '梅园中班',
          type: 13
        },{
          label: '梅园大班',
          type: 14
        },{
          label: '袁花',
          type: 10
        },{
          label: '袁花龙溪',
          type: 18
        },{
          label: '硖石',
          type: 11
        },{
          label: '桃园',
          type: 12
        },{
          label: '黄湾',
          type: 15
        },{
          label: '海昌',
          type: 16
        },{
          label: '海宁机关',
          type: 17
        },{
          label: '体验托班',
          type: 19
        },{
          label: '体验小班',
          type: 20
        },{
          label: '体验中班',
          type: 21
        },{
          label: '体验大班',
          type: 22
        },{
          label: '长安',
          type: 23
        }]
      };
          // bind this
      this.onRolesChange = this.onRolesChange.bind(this);
      this.searchSchool = this.searchSchool.bind(this);
      this.handleInput = this.handleInput.bind(this);
      this.handleEditOk = this.handleEditOk.bind(this);
      this.handleEditCancel = this.handleEditCancel.bind(this);
      this.forceUpdate = this.forceUpdate.bind(this);
      
      
  }

  componentWillMount(){
    CurrentRoleActions.changeCurrentUserRole(this.state.systemAdmin);
  }
  componentDidMount(){
    UserRoleStore.addChangeListener(this.onRolesChange);
  }
  componentWillUnmount(){
    UserRoleStore.removeChangeListener(this.onRolesChange);
  }

  onRolesChange() {
    this.setState({
      roles: UserRoleStore.getState()
    });
  }

  handleInput(e) {
    this.setState({
      value: e.target.value
    })
  }

  //搜索系统
  searchSchool() {
    if (this.state.searchType == 'school') {
      DataService.searchSchool({ search: this.state.value }).then(res => {
        this.setState({
          hasSearched: true,
          searchSchoolResult: res.schools
        })
      })
    } else if (this.state.searchType == 'teacher') {
      DataService.searchUser({ info: this.state.value }).then(res => {
        let searchSchoolResult = [];
        if (res) {
          searchSchoolResult.push(res)
        }
        this.setState({
          searchSchoolResult,
          hasSearched: true
        })
      })
    } else {
      DataService.searchStudent({ info: this.state.value }).then(res => {
        this.setState({
          searchSchoolResult: res,
          hasSearched: true
        })
      })
    }
  }
  handleEditCancel() {
    this.setState({
      editTeacherVisible: false,
      changeState: false,
      searchTeacher: undefined,
    })
  }

  handleEditOk() {
    let searchTeacher = this.state.searchTeacher;
    if (this.state.changeState) {
      if (searchTeacher.mobile_phone.length != 11) {
        message.error('请输入正确的手机号')
        return;
      }
      DataService.updateUserMobile({ id: searchTeacher.id, mobile_phone: searchTeacher.mobile_phone}).then(res => {
        this.setState({
          editTeacherVisible: false,
          searchTeacher: undefined,
          changeState: false
        })
      }, (response) => {
        if (response.errorMessage) {
          if (response.errorMessage.errors[0].code == 51) {
            message.error('该手机号已存在');
          } else {
            message.error('手机号更新失败，请重试');
          }
        }
      })
    }
  }
  unbindWxAccount(id){
    DataService.unbindUserWxAccount(id).then(res=>{
      console.log(`success unbind!`)
      message.info('成功解除绑定')
      let searchTeacher = this.state.searchTeacher;
      searchTeacher.wx_account = null;
      this.setState({
        searchTeacher,
      })
    },(error)=>{
      console.log(error)
      if (error.errorMessage) {
        switch(error.errorMessage.errors[0].code) {
          case 11:
            message.error('未获取正确的用户信息！')
            break;
          case 41:
            message.error('未找到用户！')
            break;
          case 42:
            message.error('用户未绑定微信账户！')
            break;
          case 71:
            message.error('访问错误，请检查您的网络情况！')
            break;
        }
      }
    })
  }
  _editTeacherModal() {
    let searchTeacher = this.state.searchTeacher;
    return (
      <Modal className="school-admin-add-teacher-modal"
        visible={this.state.editTeacherVisible}
        title={null}
        onOk={this.handleEditOk}
        onCancel={this.handleEditCancel}
        maskClosable={false}
        footer={[
          <Button key="submit" type="primary" size="large" onClick={this.handleEditOk} className="footer-btn" disabled={!this.state.changeState}>
            确认修改
          </Button>,
        ]}>
        <div className="edit-student">
          <div className="edit-avatar">
            <div className="avatar-box">
              {searchTeacher && searchTeacher.wx_account?
              <div style={{ position: 'relative', display: 'flex', alignItems: 'flex-end' }}>
                <img className="avatar" src={searchTeacher.wx_account.avatar_url} />
                <Popconfirm placement="rightBottom" title='是否解除与微信账户的绑定' onConfirm={this.unbindWxAccount.bind(this,searchTeacher.id)} okText="是" cancelText="否">
                    <Button style={{position:'absolute', buttom:0,right:0 }} shape="circle" icon='edit'/>
                </Popconfirm>
              </div>
               : '未绑定微信账号'}
            </div>
          </div>
        </div>
        <div className="modal-teacher-info">
          <div className="modal-input-wrapper">
            <span className="modal-label">
              姓名</span>
            <div className="modal-input" style={{display: 'inline-block'}}>{searchTeacher ? searchTeacher.full_name : ''}</div>
          </div>

          <div className="modal-input-wrapper">
            <span className="modal-label"><span className="red-point">*</span>
              手机号</span>
            <input className="modal-input" type="number" value={searchTeacher ? searchTeacher.mobile_phone : ''} onChange={this.changeTeacherMobile.bind(this)}/>
          </div>
        </div>
      </Modal>
    )
  }

  changeSearchLabel(type) {
    this.setState({
      searchType: type,
      value: '',
      searchSchoolResult: [],
      hasSearched: false
    })
  }

  changeTeacherMobile(e) {
    let searchTeacher = this.state.searchTeacher;
    searchTeacher.mobile_phone = e.target.value;
    this.setState({
      searchTeacher,
      changeState: true
    })
  }
  selectSchool(id) {
    if (this.state.searchType == 'school') {
      let schoolId = id;
      let school = this.state.searchSchoolResult.find((school) => school.id == schoolId);
      let systemAdmin = this.state.systemAdmin;
      systemAdmin.associatObj = {
        id: school.id,
        schoolId: schoolId,
        schoolName: school.name,
        isSchoolAdmin: true,
        searched:true,
      }
      CurrentRoleActions.changeCurrentUserRole(systemAdmin);
      hashHistory.push(`albums/manage`);
    } else {
      let searchTeacher = this.state.searchSchoolResult[0];
      this.setState({
        editTeacherVisible: true,
        searchTeacher,
        value: '',
        searchSchoolResult: [],
        hasSearched:false,
      })
    }
  }
}
class SearchTable extends Component{
  handleButtonClick = () => {
    const { onClick } = this.props;
    onClick('Button clicked!');
  }
  handleChange = (event) => {
    this.props.onChange(event);
  }
  render(){
    const{searchType,value} = this.props
    return(
      <div>
          {/* 搜索学校 || 用户 || 学生 */}
          {searchType == 'school' || searchType == 'teacher' || searchType == 'student' ? <div className="search-teacher-box">
          <div className="input-box">
            <Search onSearch={this.handleButtonClick} onChange={this.handleChange} value={value} placeholder={searchType == 'school' ? '请输入学校名称' : (searchType == 'teacher' ? '用户手机号/ID' : '输入学生姓名')}/>
          </div>
        </div> : ''}
      </div>
    )
  }
}
export class SchoolSearchPage extends AdminIndexPage {
  componentDidMount(){
    super.componentDidMount();
    this.setState({
      searchType:'school'
    })
  }
  render() {
    let { value, searchSchoolResult, hasSearched } = this.state;
    return (
      <div className="system-search-modal">
        <SearchTable searchType='school' value={value} onClick={this.searchSchool} onChange={this.handleInput}/>
        <div className="search-teacher-box">
          <div className="search-result">
            {searchSchoolResult && searchSchoolResult.map((item, index) => {
              return <div className={"teacher-info"} key={"search-" + index}>
                <div className="teacher-name">{item.name}</div>
                  <div className="btn" onClick={this.selectSchool.bind(this, item.id)}>选择</div>
              </div>
            })}
            {(hasSearched && searchSchoolResult.length == 0) && <div className="no-result">无此学校，请重新搜索</div>}
          </div>
        </div>
      </div>
    )
  }
}
export class UserSearchPage extends AdminIndexPage {
    componentDidMount(){
      super.componentDidMount();
      this.setState({
        searchType:'teacher'
      })
    }
    render() {
      let { value, searchSchoolResult, hasSearched } = this.state;
      return (
        <div className="system-search-modal">
          <SearchTable searchType='teacher' value={value} onClick={this.searchSchool} onChange={this.handleInput}/>
          {this._editTeacherModal()}
          <div className="search-teacher-box">
            <div className="search-result">
              {searchSchoolResult && searchSchoolResult.map((item, index) => {
                return <div className="teacher-info" key={"search-" + index}>
                  <div className="student-name">{item.full_name}</div>
                  <div className='student-name'>{item.wx_account?'已绑定微信':'未绑定微信'}</div>
                  <div className="teacher-name">{item.mobile_phone} 
                      {item.parent_record ? <div> <div>家长身份：</div> {item.parent_record.children.map((children,key)=>{return <div className='parent-record' key = {"children-"+key}>{children.class_record.school_name} {children.class_record.name} {children.full_name}家长</div>})}</div>:''}
                      {item.teacher_record? <div><div>老师身份：</div>{item.teacher_record.class_records.map((i,key) => {return <div className="teacher-grade-name" key={"grade-" + key}>{i.school_name} {i.name} 老师</div> })}</div> :''}
                  </div> 
                  <div className="btn" onClick={this.selectSchool.bind(this, item.id)}>{'编辑'}</div>
                </div>
              })}
              {(hasSearched && searchSchoolResult.length === 0) && <div className="no-result">无此用户，请重新搜索</div>}
            </div>
          </div>
        </div>
      )
    }
  }
export class StudentSearchPage extends AdminIndexPage {
  componentDidMount(){
    super.componentDidMount();
    this.setState({
      searchType:'student'
    })
  }
  getStudnetPageCount(id,gradeNumber){
    const student_semesters = SharedTools.getStudentSemesters(gradeNumber)
    const semesters = student_semesters.map(semester => semester.semester)
    const url = `/api/v1/archives/render_page_count_all?semesters=[${semesters.join(',')}]&student_id=${id}`
    var that = this
    $.ajax({
      url: url,
      success: function (data) {
        const pageArray = Object.entries(data).map(([semester, pageCount]) => ({
          semester: parseInt(semester),
          'page-count': parseInt(pageCount)
        }));
        that.setState({
          studentPageCount:pageArray
        })
      },
      error: function (error) {
        console.log(error)
      }
    });
  }
  showStudentPageCount(id,gradeNumber){
    this.getStudnetPageCount(id,gradeNumber)
    this.setState({
      studentPageVisible:true,
      searchId:id,
    })
  }
  forceUpdate(id,semester){
    let data = {
      student_id:id,
      semester,
    }
    DataService.updateBookOrders(data).then((res)=>{
      message.success("更新成功！")
    }).catch((error)=>{
      console.log(error)
      switch(error.errorMessage.errors[0].code){
        case 11:
          message.error("更新失败，缺少必要参数！")
          break;
        case 42:
          message.error("更新失败，学生姓名未找到！")
          break;
        case 43:
          message.error("更新失败，学生未在该学校！")
          break;
        case 71:
          message.error("更新服务器响应失败！")
          break;
      }
    })
  }
  _pageCountModal(){
    const columns = [
      { title: '学期', dataIndex: 'semester', key: 'semester', width: '100px' },
      { title: '档案页数', dataIndex: 'page-count', key: 'page-count', width: '60px'},
      {title:'操作',key:'action',width:'20px',render: (text, record) => (
        <span>
          <p style={{ padding: '3px 0' }} onClick={this.forceUpdate.bind(this,this.state.searchId,record.semester)}><a>更新</a></p>
        </span>
      ),}
    ]
      return (
         <Modal className="school-admin-add-teacher-modal"
           visible={this.state.studentPageVisible}
           title = '学生档案页数'
           footer={[
             <Button key="back" type="primary" onClick={()=>{this.setState({
                  studentPageVisible:false,
                  studentPageCount:[],
                  })}}
            >关闭</Button>,
           ]}
           maskClosable={false}
        //   onCancel={this.closeStudentPageCount()}
           >
          <div className="modal-teacher-info">
            <Table columns={columns} dataSource={this.state.studentPageCount} rowKey={record => record.semester} pagination={false} bordered />
          </div>
       </Modal>
      )
    
  }
    render() {
      let { value, searchSchoolResult, hasSearched } = this.state;
      return (
        <div className="system-search-modal">
          <SearchTable searchType='student' value={value} onClick={this.searchSchool} onChange={this.handleInput}/>
          <div className="search-teacher-box">
            <div className="search-result">
              {searchSchoolResult && searchSchoolResult.map((item, index) => {
                return <div className={"teacher-info" +  " student-info"} key={"search-" + index}>
                  <div className="student-name">id: {item.id}</div> 
                  <div className="student-name">{item.full_name}</div>
                  <div className="teacher-name">{item.class_record.school_name + '(学校id: ' + item.class_record.school_id + ')'}</div>
                  <div className="teacher-phone">{item.class_record.name + '(班级id: ' + item.class_record.id + ')'}</div> 
                  <div className="btn" onClick={this.showStudentPageCount.bind(this,item.id,item.class_record.grade_number)}>查询页数</div>
                </div>
              })}
              {(hasSearched && searchSchoolResult.length == 0) && <div className="no-result">无此学生，请重新搜索</div>}
            </div>
          </div>
          {this._pageCountModal()}
        </div>
      )
    }
  }
export class SetPublicAccountPage extends AdminIndexPage {
    componentDidUpdate(prevProps){
      if (prevProps.location!==this.props.location&&prevProps.params.type!==this.props.params.type){
          this.getAutoRepliesList()
      }
    }
    componentDidMount(){
      super.componentDidMount();
      this.getAutoRepliesList()
    }    
    //公众号管理系统
    getAutoRepliesList() {
      let isAccountAdd = parseInt(this.props.params.type)==0?false:true
      if (isAccountAdd) {
        DataService.getAutoRepliesMedias().then(res => {
          this.setState({
            autoReplies: res,
            isAccountAdd
          })
        })
      } else {
        DataService.getAutoRepliesList().then(res => {
          this.setState({
            autoReplies: res,
            isAccountAdd
          })
        })
      }
    }
  toolAccount(record) {
    if (this.state.isAccountAdd) {
      this.setState({
        keywordModalVisible: true,
        repliesRecord: record
      })
    } else {
      Modal.confirm({
        content: '是否确认删除文章所对应的关键词?',
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          DataService.deleteAutoRepliesMedias(record.id).then(res => {
            message.success('已删除成功');
            let autoReplies = this.state.autoReplies;
            let index = autoReplies.findIndex((item) => item.id == record.id);
            autoReplies.splice(index, 1);
            this.setState({
              autoReplies
            })
          }, (response) => {
            message.error('该关键词删除失败！')
          })
        }
      });
    }
  }
    _setOfficialAccountsModal() {
      const columns = [
        { title: '文章标题', dataIndex: 'title', key: 'title',width:150},
        { title: '文章id', dataIndex: 'id', key: 'id', width: 150},
        {
          title: '操作',
          key: 'operation',
          width: 100,
          render: (text, record) => <a href="javascript:;" onClick={this.toolAccount.bind(this, record)}>{this.state.isAccountAdd ? '新增' : '删除'}</a>,
        },
      ];
      if (!this.state.isAccountAdd) {
        columns.map((item) => {
          if (item.dataIndex == 'id') {
            item.dataIndex = 'media_id';
            item.key = 'media_id';
          }
        })
        columns.unshift({ title: '关键词', dataIndex: 'key_word', key: 'key_word', width: 120 })
      }
      
      return (
        <Table columns={columns} dataSource={this.state.autoReplies} rowKey={record => record.id} style={{width:'800px'}} pagination={false} bordered/>
      )
    }
    _inputKeywordModal() {
      return (
        <Modal
          className="graduated-modal"
          footer={[
            <Button key="back" type="primary" onClick={() => this.setState({ keywordModalVisible: false, inputKeyword: '' })}>关闭</Button>,
            <Button key="sure" type="primary" onClick={this.submitKeyword.bind(this)}>确认</Button>,
          ]}
          title={'新增关键词'}
          visible={this.state.keywordModalVisible}
          maskClosable={false}
          onCancel={() => this.setState({ keywordModalVisible: false, inputKeyword: '' })}
        >
          <Input placeholder="请输入关键词" onChange={(e) => this.setState({ inputKeyword: e.target.value })} value={this.state.inputKeyword}/>
        </Modal>
      )
    }
    submitKeyword() {
      if (this.state.inputKeyword) {
        let data = {
          media_id: this.state.repliesRecord.id,
          key_word: this.state.inputKeyword,
        }
        this.createAutoReplies(data);
      } else {
        message.error('关键词不能为空！');
      }
    }
  
    createAutoReplies(data) {
      DataService.createAutoReplies(data).then(res => {
        message.success('已创建成功');
        this.setState({
          keywordModalVisible: false,
          inputKeyword: '',
        })
      }, (response) => {
        if (response.errorMessage) {
          if (response.errorMessage.errors[0].code == 51) {
            Modal.confirm({
              content: '该文章已经创建过关键词，是否继续创建?',
              okText: '确认',
              cancelText: '取消',
              onOk: () => {
                data.confirm = true;
                this.createAutoReplies(data)
              }
            });
          } else {
            message.error('手机号更新失败，请重试');
          }
        }
      })
    }
    render() {
      return (
        <div className="system-search-modal">
          <div className="set-official-accounts-container">
            {this._setOfficialAccountsModal()}
            {this._inputKeywordModal()}
          </div>
        </div>
      )
    }
  }
export class PdfTaskPage extends AdminIndexPage {
  //pdf管理系统
  onSelectTask(type, value, option) {
    let task = this.state.task;
    switch (type) {
      case 'school':
        if(task.student_id.length!=0){
          this.showSchoolChangeConfirm(value)
        }
        else{
          this.changeSchool(value)
        }
        break;  
      case 'semester':
        task.semester = value
        break;
      case 'class':
        task.class_id = value
        task.addStudent = undefined
        if(value){
          DataService.getAllStudents(value).then(res=>{
            this.setState({
              studentList: res,
            })
          })
        }
        break;
      case 'student':
        task.addStudent = {id:value.key,name:value.label}
        break;
      default:
        break;
    }
    this.setState({
      task
    })
  }
  showSchoolChangeConfirm(value) {
    let connect = this
    schoolChangeConfirm({
      title: '是否确定更换学校?',
      content: '修改学校会导致失去已添加的学生',
      okText: '确认',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        connect.changeSchool(value)
      },
      onCancel() {
        
      },
    });
  }
  changeSchool(value){
    let task = this.state.task
    task.school_id = value
    task.class_id = null
    task.addStudent = undefined
    task.student_id = []
    if(value){
      DataService.getAllClassRecord(value).then(res=>{
        this.setState({
          classList: res,
        })
      }), (response) => {
        this.setState({
          classList:[]
        })
        }
      }
  }
    _createTaskModal() {
      
      const all_semesters = SharedTools.getAllSemesters(SharedTools.getCurrentSemester(), 20171)
      const semesters = all_semesters.map(semester => semester.semester)
      const schools = this.state.schoolList.map(school => <Option value={String(school.id)} key={school.id}>{school.name}</Option>)

      return (
        <div className="task-list-modal" >
          <div className="ant-modal-body">
            <span>新建PDF任务</span>
          <div className="select-box">
            <label>学校：</label>
            <Select
              showSearch
              style={{ width: 200 }}
              placeholder="学校名称"
              optionFilterProp="children"
              onSelect={this.onSelectTask.bind(this, 'school')}
              value={this.state.task.school_id ? String(this.state.task.school_id) : this.state.task.school_id}
              filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              {schools}
            </Select>
          </div>
          <div className="select-box">
            <label>学期：</label>
            <Select
              style={{ width: 200 }}
              placeholder="选择学期"
              onSelect={this.onSelectTask.bind(this, 'semester')}
              value={this.state.task.semester ? String(this.state.task.semester) : this.state.task.semester}
            >
              {semesters.map((semester) => <Option value={String(semester)} key={semester}>{semester}</Option>)}
            </Select>
          </div>
          <div>
            {this.state.task.student_id.length!=0?this.state.task.student_id.map(student =><div className="student-list" key={student.id}>{student.name} <Button key={student.id} onClick={this.deleteStudent.bind(this,student.id)}>删除</Button></div>)
            :<div className='student-list'>* 未添加学生默认为全部学生</div>
            }
          </div>
          <div className="select-box">
            <label>是否打印：</label>
            <Switch checkedChildren={<Icon type="check" />} unCheckedChildren={<Icon type="close" />} defaultChecked onChange={this.switchChange.bind(this, 'is_printable')}/>
          </div>
          <div className="select-box">
            <label>是否压缩：</label>
            <Switch checkedChildren={<Icon type="check" />} unCheckedChildren={<Icon type="close" />} defaultChecked onChange={this.switchChange.bind(this, 'is_compress')} />
          </div>
          <Button icon="plus" key="add" type='primary' onClick={this.showAddStudent.bind(this)}>添加学生</Button>,
          <Button key="sure" type="primary" onClick={this.createTask.bind(this)}>新建</Button>
        </div>
        </div>
      )
    }
    onSelectSemester(value){
      this.setState({
        taskSemester:value
      })
      this.getTaskList()
    }

    _getTaskListModal() {
      let filterArray = []
      const all_semesters = SharedTools.getAllSemesters(SharedTools.getCurrentSemester(), 20171)
      const semesters = all_semesters.map(semester => semester.semester)
      semesters.map(semester=>{
        filterArray.push({text:semester.toString(),value:semester})
      })
      let taskList = (this.state.taskSemester?this.state.taskList.filter(task=>{return(task.semester===Number(this.state.taskSemester))}):[])
      const columns = [
        { title: '学校', dataIndex: 'school_name', key: 'school_name' },
        { title: '打印', dataIndex: 'is_printable', key: 'is_printable',width: '50px', render: (text, record) => text ? '是' : '否'},
        { title: '压缩', dataIndex: 'is_compress', key: 'is_compress',width: '50px', render: (text, record) => text ? '是' : '否' },
        { title: '总人数', dataIndex: 'student_count', key: 'student_count',width: '60px', },
        { title: 'PDF完成人数', dataIndex: 'pdf_rate', key: 'pdf_rate',width: '100px',render: (value, record) => value},
        { title: 'PDF错误人数', dataIndex: 'pdf_error_rate', key: 'pdf_error_rate',width: '100px',render: (value, record) => value },
        { title: '已推送家长', dataIndex: 'parent_push', key: 'parent_push',width: '100px', render: (text, record) => text ? '是' : '否' },
        { title: '已推送老师', dataIndex: 'teacher_push', key: 'teacher_push',width: '100px', render: (text, record) => text ? '是' : '否'},
        {
          title: '操作',
          key: 'operation',
          width: '50px',
          render: (text, record) => <a href="javascript:;"><Popover placement="leftTop" title={'操作'} content={(
            <div className="task-operation">
              <p style={{ padding: '3px 0' }} onClick={this.operationTask.bind(this, 'render_pdf', record.id)}><a>生成PDF</a></p>
              <p style={{ padding: '3px 0' }} onClick={this.operationTask.bind(this, 'render_updated_pdf', record.id)}><a>更新PDF</a></p>
              <p style={{ padding: '3px 0' }} onClick={this.operationTask.bind(this, 'try_error_pdf', record.id)}><a>重试失败的PDF</a></p>
              {!record.parent_push ? <p style={{ padding: '3px 0' }} onClick={this.operationTask.bind(this, 'push_parent', record.id)}><a>推送给家长</a></p> : ''}
              {!record.teacher_push ? <p style={{ padding: '3px 0' }} onClick={this.operationTask.bind(this, 'push_teacher', record.id)}><a>推送给老师</a></p> : ''}
              {/* <p style={{padding: '3px 0'}}><a>结束任务</a></p> */}
            </div>
          )} trigger="click">操作</Popover></a>,
        },
      ];
      return (
        <div>
        <label>请选择学期:</label>
        <Select
          style={{ width: 120,left:'10px' }}
          placeholder="选择学期"
          onSelect={this.onSelectSemester.bind(this)}
          value={this.state.taskSemester ? String(this.state.taskSemester) : null}
        ><Option value={null}>无</Option>
          {semesters.map(item=><Option value={String(item)} key={item}>{item}</Option>)}
        </Select>
        <Table title={()=>'PDF任务列表'} columns={columns} dataSource={taskList} rowKey={record => record.id} pagination={{pageSize:10}}  bordered />
       </div> 
      )
    }
    _addStudentModal(){
      return(
        <Modal
          className='task-list-modal'
          title={'添加学生'}
          visible={this.state.addStudentVisible}
          maskClosable={false}
          footer={[
            <Button key="sure" type="primary" onClick={this.confirmAddStudent.bind(this)}>添加</Button>,
            <Button key="back" type="primary" onClick={this.closeAddStudent.bind(this)}>取消</Button>,
          ]}
        >
          <div className="select-box">
            <label>班级：</label>
            <Select
              style={{ width: 200 }}
              placeholder="选择班级"
              onSelect={this.onSelectTask.bind(this, 'class')}
              value={this.state.task.class_id ? String(this.state.task.class_id) : null}
            ><Option value={null}>全部</Option>
              {this.state.task.school_id? this.state.classList.map(item=><Option value={String(item.id)} key={item.id}>{item.name}</Option>):null}
            </Select>
          </div>
          <div className="select-box">
            <label>学生：</label>
            <Select
              style={{ width: 200 }}
              placeholder="选择学生"
              onSelect={this.onSelectTask.bind(this, 'student')}
              labelInValue
              value={{key:(this.state.task.class_id?(this.state.task.addStudent  ? String(this.state.task.addStudent.name) : null):null), label:''}}
            ><Option value={null}>全部</Option>
              {this.state.task.class_id? this.state.studentList.map(item=><Option value={String(item.id)} key={item.id}>{item.full_name}</Option>):null}
            </Select>
          </div>
        </Modal>
      )
    }
    showAddStudent(){
      if(!this.state.task.school_id){
        message.error('请先选择学校')
      }
      else{
        this.setState({
          addStudentVisible:true
        })
      }
    }
    confirmAddStudent(){
      let student_list = this.state.task.student_id
      let task = this.state.task
      if(!this.state.task.addStudent){
        message.error('请选择学生')
      }
      else if(student_list.find((student)=>student.id===task.addStudent.id)){
        message.error('学生已存在')
      }
      else{
        student_list.push(this.state.task.addStudent)
        task.student_id = student_list
        task.addStudent = undefined
        task.class_id = undefined
        this.setState({
          addStudentVisible:false,
          task
        })
      }
    }
    deleteStudent(id){
      let task = this.state.task
      task.student_id = task.student_id.filter(student=>{
        return student.id!==id
      })
      this.setState({
        task
      })
    }
    closeAddStudent(){
      let task = this.state.task
      task.addStudent = undefined
      task.class_id = undefined
      this.setState({
        addStudentVisible:false,
        task,
      })
    }
    switchChange(type, checked) {
      let task = this.state.task;
      type == 'is_compress' ? task.is_compress = checked : task.is_printable = checked;
      this.setState({
        task
      })
    }
  
    createTask() {
      let task = this.state.task;
      if (task.school_id && task.semester) {
        DataService.createTask(task).then(res => {
          message.success('创建成功')
          this.getTaskList()
          this.setState({
            showCreateTask: false,
            classList: [],
            studentList: [],
            task: {
              school_id: undefined,
              semester: undefined,
              class_id: undefined,
              student_id: [],
              is_compress: this.state.task.is_compress,
              is_printable: this.state.task.is_printable
            }
          })
        }, (response) => {
          message.error('创建失败')
        })
      } else if (!task.school_id) {
        message.info('请选择学校')
      } else if (!task.semester) {
        message.info('请选择学期')
      }
    }
  
    closeTaskModal() {
      this.setState({
        showCreateTask: false,
        classList: [],
        studentList: [],
        task: {
          school_id: undefined,
          semester: undefined,
          class_id: undefined,
          student_id: [],
          is_compress: this.state.task.is_compress,
          is_printable: this.state.task.is_printable
        }
      })
    }
  
    operationTask(operation, id) {
      if (operation == 'render_pdf') {
        DataService.taskRenderPdf(id).then(res => {
          message.success('操作成功')
        }, (response) => {
          message.error('PDF生成失败')
        })
      } 
      else if (operation == 'render_updated_pdf') {
        DataService.taskRenderUpdatedPdf(id).then(res => {
          message.success('操作成功')
        }, (response) => {
          message.error('PDF更新失败')
        })
      } 
      else if (operation == 'try_error_pdf') {
        DataService.taskTryErrorPdf(id).then(res => {
          message.success('已提交重试任务')
        }, () => {
          message.error('提交重试任务失败')
        })
      }
      else if (operation == 'push_parent') {
        DataService.taskPushParent(id).then(res => {
          message.success('操作成功')
        }, (response) => {
          message.error('推送给老师操作失败')
        })
      } else if (operation == 'push_teacher') {
        DataService.taskPushTeacher(id).then(res => {
          message.success('操作成功')
        }, (response) => {
          message.error('推送给老师操作失败')
        })
      }
    }
  
    onSelectTask(type, value, option) {
      let task = this.state.task;
      switch (type) {
        case 'school':
          if(task.student_id.length!=0){
            this.showSchoolChangeConfirm(value)
          }
          else{
            this.changeSchool(value)
          }
          break;  
        case 'semester':
          task.semester = value
          break;
        case 'class':
          task.class_id = value
          task.addStudent = undefined
          if(value){
            DataService.getAllStudents(value).then(res=>{
              this.setState({
                studentList: res,
              })
            })
          }
          break;
        case 'student':
          task.addStudent = {id:value.key,name:value.label}
          break;
        default:
          break;
      }
      this.setState({
        task
      })
    }
    showSchoolChangeConfirm(value) {
      let connect = this
      schoolChangeConfirm({
        title: '是否确定更换学校?',
        content: '修改学校会导致失去已添加的学生',
        okText: '确认',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          connect.changeSchool(value)
        },
        onCancel() {
          
        },
      });
    }
    changeSchool(value){
      let task = this.state.task
      task.school_id = value
      task.class_id = null
      task.addStudent = undefined
      task.student_id = []
      if(value){
        DataService.getAllClassRecord(value).then(res=>{
          this.setState({
            classList: res,
          })
        }), (response) => {
          this.setState({
            classList:[]
          })
          }
        }
    }
    getTaskList(){
      DataService.getTaskList().then(res => {
        this.setState({
          taskList: res
        })
      })
    }
    componentDidMount(){
      super.componentDidMount()
      DataService.getAllSchools('active').then(res=>{
        this.setState({
          schoolList:res,
        })
      })
      this.getTaskList()
    }
    render() {
        return (
        <div className="system-search-modal">
          <div className="set-official-accounts-container">
          </div>
          {this.props.params.task==0?this._getTaskListModal():this._createTaskModal()}
          {this._addStudentModal()}
        </div>
        )
    }
}
export class UploadReviewPage extends AdminIndexPage {
    uploadFile() {
      let { file, upload_type, upload_theme_type} = this.state;
      if (!file) {
        message.error('请上传文件!')
        return
      }
      if (!upload_type) {
        message.error('请选择上传模板类型!')
        return
      }
      if (!upload_theme_type) {
        message.error('请选择上传模板主题类型!')
        return
      }
      this.setState({
        uploading: true
      })
      let fileName = file.name.substring(0, file.name.lastIndexOf("."));

      let data = {
        file: file,
        type: upload_type,
        theme_type: upload_theme_type,
        file_name: fileName
      }
      DataService.createByExcel(data).then(res => {
        message.success('上传成功!')
        this.setState({
          uploading: false
        })
      }, (error) => {
          if (error && error.errorMessage.errors[0].code == 11) {
            message.error('缺少参数') 
          } else if (error && error.errorMessage.errors[0].code == 12) {
            message.error('文件名命名错误')
          } else if (error && error.errorMessage.errors[0].code == 21) {
            message.error('模板已存在')
          } else if (error && error.errorMessage.errors[0].code == 22) {
            message.error('模板类型不匹配')
          } else if (error && error.errorMessage.errors[0].code == 23) {
            message.error('评价条目过多')
          } else if (error && error.errorMessage.errors[0].code == 41) {
            message.error('文件未找到')
          } else if (error && error.errorMessage.errors[0].code == 42) {
            message.error('主题未找到')
          } else {
            message.error(`上传失败，code:${error.errorMessage.errors[0].code}`)
          }
          this.setState({
            uploading: false
          })
      })
    }
    getValue(e) {
      let file = ReactDOM.findDOMNode(this.fileDom).files[0];
      this.setState({
        file
      })
    }

    _uploadTemplateView() {
      let { type_options } = this.state;
      let { theme_options } = this.state;
      return (
        <Spin spinning={this.state.uploading}>
          <div className="import-container">
            <span>请选择要导入的文件</span>
            <div className="import-box">
              <input type="file" ref={(input) => { this.fileDom = input}} className="import-file" onChange={this.getValue.bind(this)} value={this.state.fileName} />
            </div>
            <Select 
              style={{ width: 120 }}
              onChange={(value) => this.setState({ upload_type: value})}>
              {type_options.map(option => 
                <Option value={String(option.type)} key={String(option.type)}>
                                    {option.label}
                                  </Option>
                                )}
            </Select>
            <Select 
              style={{ width: 120 }}
              onChange={(value) => this.setState({ upload_theme_type: value})}>
              {theme_options.map(option => 
                <Option value={String(option.type)} key={String(option.type)}>
                                    {option.label}
                                  </Option>
                                )}
            </Select>
            <Button type="primary" className="info-submit" onClick={this.uploadFile.bind(this)}>上传主题评价</Button>
          </div>
        </Spin>
      )
  
    }
    render() {
      return (
        <div>{this._uploadTemplateView()}</div>
      )
    }
}




// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/album/AdminIndexPage.jsx